export const ExpandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M11.5714 7.5C11.5714 7.98398 11.1884 8.375 10.7143 8.375H1.28573C0.811625 8.375 0.428589 7.98398 0.428589 7.5C0.428589 7.01602 0.811625 6.625 1.28573 6.625H10.7143C11.1884 6.625 11.5714 7.01602 11.5714 7.5Z"
      fill="currentColor"
    />
  </svg>
);
